/* eslint-disable max-lines-per-function */
import React from 'react'
import { Flex, Typography, Box } from '@creditas-ui/react'
import { formatMoney } from 'shared/helpers'

export const CreditPaymentDetail = ({ creditPayment, product }) => {
  if (!creditPayment) {
    return null
  }

  const {
    releasedAmount,
    installmentValue,
    totalInstallments,
    totalLoanAmount,
    monthlyInterestRate,
    iofAmount,
    registrationFeeAmount,
    monthlyCetRate,
  } = creditPayment

  const boxPropsValue = {
    borderBottom: '1px solid',
    borderBottomColor: 'neutral.10',
    paddingY: '20px',
  }

  return (
    <>
      <Box mb="28px">
        <Typography color="neutral.90" component="h2" variant="headingLgLight">
          Detalhes do empréstimo <br /> pago
        </Typography>
      </Box>
      <Flex
        alignItems="end"
        flexDirection="row"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Valor liberado
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography color="neutral.90" component="p" variant="bodySmRegular">
            {formatMoney(releasedAmount)}
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Valor da parcela
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography color="neutral.90" component="p" variant="bodySmRegular">
            {formatMoney(installmentValue)}
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Total de parcelas
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography
            color="neutral.90"
            textAlign="right"
            component="p"
            variant="bodySmRegular"
          >
            {totalInstallments}x
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Total do empréstimo
          </Typography>
          <Typography color="neutral.60" component="p" variant="bodyXsRegular">
            Soma de todas as parcelas
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography
            color="neutral.90"
            textAlign="right"
            component="p"
            variant="bodySmRegular"
          >
            {formatMoney(totalLoanAmount)}
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Taxa de juros ao mês
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography
            color="neutral.90"
            textAlign="right"
            component="p"
            variant="bodySmRegular"
          >
            {monthlyInterestRate}%
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            IOF
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography
            color="neutral.90"
            textAlign="right"
            component="p"
            variant="bodySmRegular"
          >
            {formatMoney(iofAmount)}
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Tarifa de cadastro
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography
            color="neutral.90"
            textAlign="right"
            component="p"
            variant="bodySmRegular"
          >
            {formatMoney(registrationFeeAmount)}
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="70%">
          <Typography color="neutral.80" component="p" variant="bodySmRegular">
            Custo efetivo total ao mês
          </Typography>
        </Box>
        <Box {...boxPropsValue} flexBasis="30%" textAlign="right">
          <Typography
            color="neutral.90"
            textAlign="right"
            component="p"
            variant="bodySmRegular"
          >
            {monthlyCetRate}%
          </Typography>
        </Box>
      </Flex>
    </>
  )
}
